function Clock({ size = "32" }) {
	return (
		<svg height={size} width={size} viewBox={`0 0 32 32`} xmlns="http://www.w3.org/2000/svg">
			<g
				fill="#000000"
				stroke="#000000"
				strokeLinecap="square"
				strokeLinejoin="miter"
				strokeMiterlimit="10"
				strokeWidth="2"
			>
				<line fill="none" strokeLinecap="butt" x1="16" x2="16" y1="1" y2="6" />
				<line fill="none" strokeLinecap="butt" x1="31" x2="26" y1="16" y2="16" />
				<line fill="none" strokeLinecap="butt" x1="16" x2="16" y1="31" y2="26" />
				<line fill="none" strokeLinecap="butt" x1="1" x2="6" y1="16" y2="16" />
				<circle cx="16" cy="16" fill="none" r="15" stroke="#000000" />
				<polyline fill="none" points=" 10,8 16,16 22,16 " />
			</g>
		</svg>
	);
}

export default Clock;
